// FeatureFlag.js
import React from "react";
import { useSelector } from "react-redux";

const FeatureFlag = ({ feature, children }) => {
  const userCredentials = useSelector((state) => state.praxis?.praxisDetails);

  const hasExpiredTrial =
    Date.now() - new Date(userCredentials?.createdAt).getTime() >
    30 * 24 * 60 * 60 * 1000;

  const shouldBlockFeature =
    feature === "premium" &&
    userCredentials?.currentLicenseType !== "premium" &&
    userCredentials?.currentLicenseType === "free" &&
    hasExpiredTrial;

  if (userCredentials) {
    if (shouldBlockFeature) {
      return (
        <div>
          <div className="flex flex-col items-center absolute top-[55%] left-[40%] text-black z-10">
            <div>Funcionalidad Premium</div>
            <div>Para utilzar esta funcionalidad, necesita una licencia.</div>
          </div>
          <div className="blur-md pointer-events-none">{children}</div>
        </div>
      );
    }
  }

  return <>{children}</>;
};

export default FeatureFlag;
